<template>
    <svg width="32" height="50" viewBox="0 0 32 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_139_12)">
            <path opacity="0.2"
                d="M30.3631 16.7925V43.2743C30.3631 48.0941 26.4138 48.3805 21.5426 48.3805H1.63721C17.7804 46.7095 30.3631 33.2044 30.3631 16.7925Z"
                fill="currentColor" />
            <path
                d="M27.3899 1.61945H4.61048C2.96839 1.61945 1.63721 2.93631 1.63721 4.56074V45.4393C1.63721 47.0637 2.96839 48.3806 4.61048 48.3806H27.3899C29.032 48.3806 30.3631 47.0637 30.3631 45.4393V4.56074C30.3631 2.93631 29.032 1.61945 27.3899 1.61945Z"
                stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.0488 42.3188H19.9516" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_139_12">
                <rect width="32" height="50" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>